module.exports = __webpack_public_path__ + "img/pg3-title.d6786540.png";